import React from 'react';
import { Box } from '@mui/material';
import { COLORS_LIGHTGRAY } from '../../App.constants';
import { LoaderBox } from './LoaderBox';

export const BenchmarkBoxLoader: React.FC = () => {
  return (
    <Box
      height={'135px'}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      alignContent={'center'}
    >
      <Box
        height={'36px'}
        display={'flex'}
        flexDirection={'column'}
      >
        <LoaderBox />
      </Box>
      <Box
        height={'50px'}
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        borderTop={`1px solid ${COLORS_LIGHTGRAY}`}
        borderBottom={`1px solid ${COLORS_LIGHTGRAY}`}
      >
        <LoaderBox />
      </Box>
      <Box
        height={'50px'}
        display={'flex'}
        flexDirection={'column'}
        width={'100%'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <LoaderBox />
      </Box>
    </Box>
  );
};

BenchmarkBoxLoader.displayName = 'BenchmarkBoxLoader';
